import React, { useEffect, useRef } from 'react';

import { Exchange } from './exchange/Exchange';
import { ExchangePoint } from './exchangePoint/ExchangePoint';
import { Benefits } from './benefits/Benefits';
import { Reserves } from './reserves/Reserves';
import { PopularExchange } from './popularExchange/PopularExchange';
import { FAQ } from './faq/Faq';

import './home.scss';

export const Home = () => {
  const ref = useRef();

  useEffect(() => {
    document.querySelector('body').scrollIntoView({ behavior: 'smooth' });
  }, [ref]);

  return (
    <div className="home" ref={ref}>
      <Exchange />
      <ExchangePoint />
      <Benefits />
      <Reserves />
      <PopularExchange />
      <FAQ />
    </div>
  );
};
